/**
 * Blog posts registry.
 *
 * To add a new post:
 * 1. Add images under src/assets/blog/covers and/or src/assets/blog/images
 * 2. Create a post file in this folder (copy an existing one)
 * 3. Import the image(s) at the top of the post file and use them in cover/content
 * 4. Import the post below and add it to the `posts` array
 */

import gitopsAksGke from './gitops-aks-gke';
import passwordlessCloudAccess from './passwordless-cloud-access';

const posts = [
  gitopsAksGke,
  passwordlessCloudAccess
];

export const getAllPosts = () =>
  [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));

export const getLatestPosts = (count = 3) => getAllPosts().slice(0, count);

export const getPostBySlug = (slug) => posts.find((post) => post.slug === slug);

export default posts;
